module.exports = __webpack_public_path__ + "static/butler-blueprint-transparent-a28af461160a18e3d7baf6e297e51f12.png";